import { render, staticRenderFns } from "./UserInvoice.vue?vue&type=template&id=c5fefd64&scoped=true&"
import script from "./UserInvoice.vue?vue&type=script&lang=js&"
export * from "./UserInvoice.vue?vue&type=script&lang=js&"
import style0 from "./UserInvoice.vue?vue&type=style&index=0&id=c5fefd64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5fefd64",
  null
  
)

export default component.exports